import { Snackbar, Dialog, ImagePreview } from '@varlet/ui'

// Varlet 全局配置
export function setupVarlet(app) {
  // 配置 Snackbar 默认选项
  Snackbar.setDefaultOptions({
    duration: 3000,
    position: 'top',
  })

  // 配置 Dialog 默认选项
  Dialog.setDefaultOptions({
    title: '提示',
    confirmButtonText: '确定',
    cancelButtonText: '取消',
  })

  // 全局挂载，方便在 JS 中使用
  app.config.globalProperties.$snackbar = Snackbar
  app.config.globalProperties.$dialog = Dialog
  app.config.globalProperties.$ImagePreview = ImagePreview

  console.log('✅ Varlet UI 初始化完成')
}

// 导出便捷方法
export { Snackbar, Dialog, ImagePreview }